export default __webpack_public_path__ + "static/media/radio_unselected.965a1edb.svg";